import * as React from 'react'
import { unwindEdges } from '@good-idea/unwind-edges'
import { PageMain, PageInner, PageFooter } from './styles'
import { InfoPage } from '@/types/sanity'
import { PortableText } from '@portabletext/react'
import Image from 'next/image'
import Head from 'next/head'
import { definitely } from '@/utils'
import { ContentBlock } from '@/components/ContentBlock'

const { useState } = React

interface ProjectsViewProps {
  projectsPage: InfoPage | null
}

export const ProjectsView: React.FC<ProjectsViewProps> = ({ projectsPage }) => {
  if (!projectsPage) {
    return <p>Sorry, project page content is missing.</p>
  }
  const { content, seo, title, contentBlocks } = projectsPage
  return (
    <PageMain className="projects">
      <Head>
        <title>{seo?.title}</title>
        <meta name="description" content={seo?.description} />
        <meta name="og:title" property="og:title" content={seo?.title} />
        <meta
          name="og:description"
          property="og:description"
          content={seo?.description}
        />
        <meta name="twitter:title" content={seo?.title} />
        <meta name="twitter:description" content={seo?.description} />
      </Head>
      <PageInner className="projects-inner">
        <h1>
          {title}{' '}
          <Image
            src={'/drawings/bear.svg'}
            alt={'Bear'}
            width={80}
            height={70}
          />
        </h1>
        {content && <PortableText value={content} />}
        <div className="content-blocks-wrapper">
          {definitely(contentBlocks).map((c, i) => {
            return (
              <ContentBlock key={`content-${i}` || 'some-key'} content={c} />
            )
          })}
        </div>
      </PageInner>
    </PageMain>
  )
}
